import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-details-standings',
  standalone: true,
  imports: [],
  templateUrl: './skeleton-details-standings-component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonStandingsComponent {}
